/* global axios */

import PortalsAPI from './portals';
import { getArticleSearchURL } from 'dashboard/helper/URLHelper.js';

class ArticlesAPI extends PortalsAPI {
  constructor() {
    super('articles', { accountScoped: true });
  }

  getArticles({
    pageNumber,
    portalSlug,
    locale,
    status,
    authorId,
    categorySlug,
    sort,
  }) {
    const url = getArticleSearchURL({
      pageNumber,
      portalSlug,
      locale,
      status,
      authorId,
      categorySlug,
      sort,
      host: this.url,
    });

    return axios.get(url);
  }

  searchArticles({ portalSlug, query, sort, status }) {
    const url = getArticleSearchURL({
      portalSlug,
      query,
      sort,
      status,
      host: this.url,
    });
    return axios.get(url);
  }

  getArticle({ id, portalSlug }) {
    return axios.get(`${this.url}/${portalSlug}/articles/${id}`);
  }

  getArticleByAssociatedArticleId({ portalSlug, associatedArticleId, locale }) {
    return axios.get(`${this.url}/${portalSlug}/articles/find_by_associated_article_id`, {
      params: {
        associated_article_id: associatedArticleId,
        locale: locale
      }
    });
  }

  updateArticle({ portalSlug, articleId, articleObj }) {
    return axios.patch(
      `${this.url}/${portalSlug}/articles/${articleId}`,
      articleObj
    );
  }

  updateAndTranslateArticle({ portalSlug, articleId, articleObj }) {
    return axios.patch(
      `${this.url}/${portalSlug}/articles/${articleId}/update_and_translate`,
      { article: articleObj }
    );
  }

  createArticle({ portalSlug, articleObj }) {
    const { content, title, author_id, category_id, associated_article_id } = articleObj;
    return axios.post(`${this.url}/${portalSlug}/articles`, {
      content,
      title,
      author_id,
      category_id,
      associated_article_id,
    });
  }

  createAndTranslateArticle({ portalSlug, articleObj }) {
    const { content, title, author_id, category_id, associated_article_id, locale, status } = articleObj;
    return axios.post(`${this.url}/${portalSlug}/articles/create_and_translate`, {
      article: {
        content,
        title,
        author_id,
        category_id,
        associated_article_id,
        locale,
        status
      }
    });
  }

  deleteArticle({ articleId, portalSlug }) {
    return axios.delete(`${this.url}/${portalSlug}/articles/${articleId}`);
  }

  reorderArticles({ portalSlug, reorderedGroup, categorySlug }) {
    return axios.post(`${this.url}/${portalSlug}/articles/reorder`, {
      positions_hash: reorderedGroup,
      category_slug: categorySlug,
    });
  }
}

export default new ArticlesAPI();
